import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from './templates/interactive.jsx';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            loader: true,
            videoLink: 'https://www.youtube.com/embed/cENYzGufiS8'
        };
        this.widgetsHelper = widgetsHelper;
        this.changeVideo = this.changeVideo.bind(this);
        return this;
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
    }

    changeVideo(link) {
        this.setState({videoLink: link});
    }

    static displayName = 'Fgvo';

    static contextTypes = {
        app: PropTypes.object
    };
}
